import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppData } from '../providers/app-data';
import { SearchResult } from '../interfaces';

@Injectable()
export class SearchData {

	appSettings: any;
    results: Array<SearchResult>;
    permanentSiteNumbers: Array<number>;
    hpmsSampleNumbers: Array<string>;
	selectedFeature: any;
	public searchMode: boolean;

	constructor(public events: Events, private appData: AppData, private http: HttpClient) {
		this.appSettings = this.appData.settings;
        this.results = [];
        this.getPermanentSiteNumbers().subscribe((permanentSites) => {
            this.permanentSiteNumbers = permanentSites;
        });
        this.getHPMSSampleNumbers().subscribe((hpmsSampleNumbers) => {
            this.hpmsSampleNumbers = hpmsSampleNumbers;
        });
	}

	public getObservableSource(text :any): Observable<any[]> {
		let params = {
			'text': text,
			'category': 'Address',
            'searchExtent': JSON.stringify(this.appSettings.searchExtent),
            'location': this.appData.getCurrentPositionOrDefault().x + "," + this.appData.getCurrentPositionOrDefault().y,
			'f': 'json'
		};

		let queryString = this.buildQueryString(params);
		let url: string = this.appSettings.searchSuggestUrl + '?' + queryString;
		if (text) {
		  return this.http.get(url)
              .map(res => {
               this.results = [];              
               this.addPermanentSitesToResults(text);
               this.addTmsSitesToResults(text);
               // add HPMS Sample Number to results
               this.addHPMSSampleToResults(text.toUpperCase());
               this.addAddressesToResults((<any>res));
               this.addCountiesToResults(text);
			   return this.results;
			});
		} else {
		  this.results = [];
		  return Observable.of(this.results);
		}
	}

	public getLocationForPlace(result: any): Observable<any[]> {

		var params = {
			'bbox': JSON.stringify(this.appSettings.searchExtent),
			'f':'json',
			'magicKey': result.magicKey,
			'outSR': this.appSettings.outSR,
			'sourceCountry': this.appSettings.sourceCountry
		};
		let queryString = this.buildQueryString(params);
		let url: string = this.appSettings.findFeatureUrl  + '?' + queryString;
		return this.http.get(url)
			.map(res => {
                let result = (<any>res);
                if (result.locations && result.locations.length > 0) {
					this.selectedFeature =result.locations[0].feature;
					return this.selectedFeature;
				} else {
					return {};
				}
			});
    }

    public getTmsSite(tmsSiteNo: number): Observable<any> {
        return this.http.get('/tire/api/tms-sites/' + tmsSiteNo).map((response) => {
            return response;
        });
    }

    public getTmsSiteByPermanentSiteNumber(permanentSiteNo: number): Observable<any> {
        return this.http.get('/tire/api/tms-sites/by-permanent-site/' + permanentSiteNo).map(response => {
            return response;
        });
    }

    public getPermanentSiteNumbers(): Observable<any> {
        // add header to prevent CORS issue during ionic serve
        const options = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Credentials': 'true'
            })
        };
        return this.http.get('/tire/api/tms-sites/permanent-site-numbers', options).map(response => {
            return response;
        });
    }

    public getHPMSSampleNumbers(): Observable<any> {
        const options = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Credentials': 'true'
            })
        };
        return this.http.get('/tire/api/hpms-samples/hpms-sample-numbers', options).map(response => {
            return response;
        });
    }

    public getHPMSSampleRecordByNumber(hpmsSampleNumber: string): Observable<any> {
        return this.http.get('/tire/api/hpms-samples/hpms-sample-numbers/' + hpmsSampleNumber).map((response) => {
            return response;
        });
    }

    private addPermanentSitesToResults(searchText: string) {
        if (!isNaN(Number(searchText))) {
            let permanentSiteNo = Number(searchText);
            if (this.permanentSiteNumbers.indexOf(permanentSiteNo) >= 0) {
                let permanentSiteResult: SearchResult = {
                    "text": "Permanent Site: " + permanentSiteNo, "permanentSiteNo": permanentSiteNo
                }
                this.results.push(permanentSiteResult);
            }            
        }
    }

    private addTmsSitesToResults(searchText: string) {
        if (!isNaN(Number(searchText))) {
            let tmsSiteNo = Number(searchText);
            let tmsResult: SearchResult = {
                "text": "TMS Site: " + tmsSiteNo, "tmsSiteNo": tmsSiteNo
            }
            this.results.push(tmsResult);
        }
    }
    // TFS 12464 Add HPMS Sample Number to Mobile Search.
    private addHPMSSampleToResults(searchText: string) {
        let hpmsSampleNumber = searchText;
            if (this.hpmsSampleNumbers.indexOf(hpmsSampleNumber) > -1) {
                let hpmsSampleResult: SearchResult = {
                    "text": "HPMS Sample Number: " + hpmsSampleNumber, "hpmsSampleNumber": hpmsSampleNumber
                }
                this.results.push(hpmsSampleResult);
            } 
    }

    private addAddressesToResults(addressResult: any) {
        let addressResults = addressResult.suggestions;
        this.results = this.results.concat(addressResults);
    }

    private addCountiesToResults(text) {
		let newResults: Array<SearchResult> = [];
		this.appData.settings.counties.forEach((c)=> {
			if (c.name.toLowerCase().indexOf(text.toLowerCase()) >= 0) {
				newResults.push({'county': c, 'text': c.name + ' County'});
			}
		});
		this.results.forEach((r)=> {
			r.county = null;
			newResults.push(r);
		});
		this.results = newResults;
	}

	public buildQueryString(params) {
		var str = [];
        for (var p in params) {
            if (params.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
            }
        }
        return str.join('&');
	}

}



// WEBPACK FOOTER //
// ./src/providers/search-data.ts